export default "__VITE_ASSET__CUCb6r5T__"